<template>
   <div class="flex flex-col min-w-full flex-grow  outline-none"
   v-bind:id="showDetails ? 'showDetails': '' " >
   <!-- :class="{'border-left border-namasteBlue':isProductInCart} -->
   <!-- :class="{'min-w-full border-l-2 border-namasteBlue': isProductInCart }" -->
     <a href="#showDetails" :class="myClass">
       <button  v-bind:class="{' text-left pb-2 w-full  focus:outline-none ': !showDetails,
       ' text-left pb-2 w-full bg-lime-100  focus:outline-none ':showDetails}"
        @click="expandDetails()"
       >
        <div class="flex flex-col pl-4 py-4 rounded-lg
        hover:bg-indigo-100 hover:shadow-lg"
        :class="{'min-w-full border-l-2 bg-blue-100 border-namasteBlue ': cartQuantity>0,  '':cartQuantity==0 }">
          <div class="flex justify-between">
          <!-- here comes the name of the food  -->
           <p :class="{'font-semibold text-warmGray-900 ':cartQuantity ==0, 'font-bold  text-blue-600': cartQuantity>0}" >
             <span  class=" font-semibold  "
              v-if="cartQuantity>0">
              {{cartQuantity}} x
              </span>
             <span> {{product.posnr }}. </span>
             <span v-html="product.name"></span>
             </p>
            <p class="px-3 text-namasteBlue text-2xl bg-warmGray-200 border border-warmGray-400 rounded-lg mr-2 mb-2 shadow-xl ">
              +
            </p>
        </div>
        <div class="">
            <!-- <img v-bind:src="pictureLink" -->
            <!-- <img src="@/assets/bilder/veganfood.jpg" -->
            <img v-bind:src="getPictureLink1"
            class="float-left max-w-28 h-32 rounded-lg object-cover mr-2"
             width="144" height="144" />
             <!-- here starts     -->
             <div class="text-sm md:text-base px-2">
                <!-- <p> mit exotischen Gewürzen, Cashewkernen, Koriander, Curcuma, Zwiebeln, Kräutern aus der Himalaya-Region und einer Zubereitungsart nach Wahl.</p> -->
               <p v-html="product.description"></p>
                <!-- Here is the price  -->
                <p v-if="decrease_price>0" class="text-namasteRed font-semibold ">
                  <span class="text-base md:text-xl"> {{ numeralFormat(currentPrice, '0,0[.]00 $')  }} </span>
                  <span class="text-tracking">, ({{ decrease_price*100}}% Rabbat auf normale Preis {{ numeralFormat(normal_price, '0,0[.]00 $')  }} )</span>
                  </p>
                <p v-else> {{ numeralFormat(currentPrice, '0,0[.]00 $')  }}  </p>
                <!-- <p v-if="isLunchTime"> <span v-bind:currentPrice="product.price1"> {{ numeralFormat(product.price1, '0,0[.]00 $')  }} </span></p> -->
                <!-- <p v-else> <span v-bind:currentPrice="product.price2">{{ numeralFormat(product.price2, '0,0[.]00 $')  }} </span></p> -->
            </div>

        </div>
         <!-- Here is product auswahl1  -->
           <!-- here is the product auswahl  -->
        <div v-if="productTypeVec.length>0"
             class="italic font-medium ">
                  <span class="font-semibold"> Auswahl Typ: </span>
                  <!-- mit Tofu (Vegan),
                  mit Paneer (vegetarisch),
                  mit bunte Gemüse (vegan/ vegetarisch),
                  mit Hühnerfleisch, mit Lammfleisch,
                  mit Ente und  mit Garnele
                   -->
                   <!-- {{product.type[0] }} -->

                  <ol v-for="(productAuswahl, pAusIdx) in product.type"
                  :Key="pAusIdx">
                      <li><div>
                        <span class="pl-2 text-gray-700 font-semibold">
                           -</span >
                        <span class="font-medium" v-html="productAuswahl"> </span>
                        </div>
                      </li>
                    </ol>
        </div>
         <!-- end of product auswahl 1  -->
         <!-- here is the product auswahl2  -->
        <div v-if="product.auswahl.length" class="italic font-medium ">
                  <span class="font-semibold">Auswahl Beilage: </span>
                  <!-- mit Tofu (Vegan),
                  mit Paneer (vegetarisch),
                  mit bunte Gemüse (vegan/ vegetarisch),
                  mit Hühnerfleisch, mit Lammfleisch,
                  mit Ente und  mit Garnele
                   -->
                   <!-- {{product.auswahl.length }} -->
                  <ol v-for="(productAuswahl, pAusIdx) in product.auswahl"
                  :Key="pAusIdx">
                      <li><div>
                         <span class="pl-2 text-gray-500 font-semibold">
                           ({{productAuswahl.posnr}}{{productAuswahl.subposnr }} )
                           <span  v-html="productAuswahl.name"></span >
                         </span>
                          <span class="pl-2 font-medium" v-html="productAuswahl.description"> </span>
                        </div>
                      </li>
                    </ol>
        </div>

        </div>
        </button>
     </a>
        <!--==================================================================-->
         <!-- The following is extension of the product after clicking on an item
         -Here is scharfstufe , product auswahl und click button  -->
        <!--==================================================================-->
<!-- v-if="showDetails || isExpanded" -->
     <!-- v-bind:id="!showDetails ? 'noDetails':''" -->
      <transition name="fade" mode="out-in" >
        <keep-alive>
        <div v-if="showDetails|| isExpanded"
          v-bind:id="!showDetails ? 'noDetails':''"
          class="slider relative flex flex-wrap md:flex p-2 bg-warmGray-200 rounded-sm" >
            <!-- first -->

            <div class="w-full md:w-1/2 m-auto ">
            <img v-bind:src="getPictureLink2" class="w-full h-auto  object-cover rounded-lg shadow-sm">
            </div>
             <!-- second  -->
            <div class="flex flex-col w-full md:w-1/2 md:border-l border-blueGray-600 pl-2">
             <div v-if="product.scharfeStufe.length"
              class="p-2 shadow-sm flex justify-between items-center">
                  <dt> <label class="mr-2 font-semibold text-warmGray-800 "> Scharfstufe </label>
                  </dt>
                  <dd>
                   <select   v-model="curScharfeStufe"
                   class="w-44 mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class="w-44 border border-warmGray-300"
                    v-for="(option) in product.scharfeStufe"
                     :key="option"
                     :curScharfeStufe =getScharfeStufe()
                      :value="option.type">
                       {{ option.type}}
                   </option>

                   </select>
                  </dd>
               </div>
            <!-- here ends  -->
            <!-- Here starts the auswahl type  -->
                <div v-if="productTypeVec.length"
                  class="px-2 py-3  shadow-sm flex justify-between items-center ">
                  <dt> <label class=" font-semibold text-warmGray-800">  Typ </label>
                   </dt>
                   <dd>
                     <select   v-model="productType"
                   class="w-44 mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class=" border border-warmGray-300"
                    v-for="option in productTypeVec"
                     :key="option"
                      :value="option">
                       {{ option}}
                   </option>

                   </select>
                   </dd>

               </div>
            <!-- Here ends the auswahl typ  -->
       <!-- Here starts the Portion  -->
                <div v-if="product.portion.length"
                  class="px-2 py-3  shadow-sm flex justify-between items-center ">
                  <dt> <label class=" font-semibold text-warmGray-800"> Portion </label>
                   </dt>
                   <dd>
                     <select   v-model="productPortion"
                    class="w-44 form-select mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class=" border border-warmGray-300"
                     v-for="option in product.portion"
                     :key="option"
                      :value="option">
                       {{ option}}
                   </option>

                   </select>
                   </dd>

               </div>
            <!-- Here ends the Portion   -->
            <div class="py-2  shadow-sm "
            v-for="(mySelection, selIdx) in product.auswahl"
            :key="mySelection">
                 <!-- {{mySelection.text}} -->
                  <label class="inline-flex items-center">
                        <input class="h-5 w-5 px-1
                        checked:text-warmGray-800"
                        type="radio" id="curcumaCurry"
                         :value="selIdx"
                         v-model="currentAuswahl">
                        <span class="ml-2">
                          <span v-html="mySelection.name"> </span>
                          <!-- v-if="mySelection.aufprice>0" -->
                          <span v-if="productPortion === mySelection.portion1"
                            class="text-warmGray-600 text-tighter font-medium">
                            (+{{ numeralFormat( mySelection.price_portion1_increase, '0,0[.]00 $') }} )
                          </span>
                           <!-- Here comes the product price if portion is klein  -->
                           <span v-if="productPortion == mySelection.portion2"
                            class="text-warmGray-600 text-tighter font-medium">
                            (+{{ numeralFormat( mySelection.price_portion2_increase, '0,0[.]00 $') }} )
                          </span>
                            <!-- Here comes the product price if portion is klein  -->
                           <span v-if="productPortion == mySelection.portion3"
                            class="text-warmGray-600 text-tighter font-medium">
                            (+{{ numeralFormat( mySelection.price_portion3_increase, '0,0[.]00 $') }} )
                          </span>

                        </span>
                      </label>
            </div>
             <div class="flex justify-between items-center ">
                 <div class=" px-3 py-1 mt-2 bg-white flex space-x-6  rounded">
                     <button class="text-2xl m-auto" @click="decreaseQuantity()"> -  </button>
                     <span class="py-2 text-xl m-auto"> {{ quantity }} </span>
                      <button class=" text-2xl m-auto" @click="increaseQuantity()">+  </button>
                 </div>
                 <div class=" rounded content-center mx-2 my-auto">
                    <button type="submit"
                    @click="addToCart(product)"
                    class="bg-namasteBlue text-blueGray-50 h-12 w-32
                    text-center rounded-lg
                    transform hover:scale-110 motion-reduce:transform-none
                    ">
                        Kaufen
                          </button>
                    </div>
             </div>
            </div>

        </div>
      </keep-alive>
    </transition>
         <!-- here is the basket  -->

   </div>
   <!-- <div class="flex bg-warmGray-50">
       <article class="p-4 flex space-x-4 ">
        <img  src="../assets/bilder/veganfood.jpg" class="flex-none w-24 h-24 rounded-lg object-cover" width="144" height="144" />
        <div class="flex justify-between bg-blueGray-400 ">
            <div>test1</div>
            <div class="self-end">
               </div>
        </div>
       </article>
    </div> -->
</template>
<script>
import { watchEffect } from 'vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    product: Object,
    cartQuantity: Number,
    myClass: String,
    showDetails: Boolean
  },
  data () {
    return {
      hovermain: false,
      // pictureLink: '/img/nepali_momo.jpg',
      priceText: '',
      quantity: 1,
      lunchTime: false,
      isExpanded: false,
      clickedOnProduct: false,
      isProductInCart: false,
      showBasket: false,
      itemQuantity: 0,
      selectedItems: {},
      curScharfeStufe: '',
      productType: this.product.type[0],
      productPortion: this.product.portion[0],
      currentAuswahl: 0,
      ihreExtras: [],
      auswahl: {}
    }
  },
  computed: {
    ...mapGetters({
      getIsLunchTime: 'getIsLunchTime',
      gesammtKosten: 'getGesammtKosten',
      cartTotal: 'getFormCartTotal',
      lieferkosten: 'getLieferKosten',
      basketItems: 'getCartProducts'
    }),
    getPictureLink1 () {
      var picLink = require(`@/assets/bilder/${this.product.pictureLink1}`)
      // console.log(picLink)
      return picLink
    },
    getPictureLink2 () {
      var picLink = require(`@/assets/bilder/${this.product.pictureLink2}`)
      // console.log(picLink)
      return picLink
    },
    // existProductType () {
    //   var tfVec = false
    //   if (this.product.type & this.product.type !== '') {
    //     tfVec = true
    //   }
    //   return tfVec
    // },
    // productPortion () {
    //   var portion = ''
    //   if (this.product.portion[2] !== '') {
    //     return this.product.portion[2]
    //   }
    //   if (this.product.portion[0] !== '') {
    //     return this.product.portion[0]
    //   }

    //   if (this.product.portion[1] !== '') {
    //     return this.product.portion[1]
    //   }
    //   return portion
    // },

    isLunchTime () {
      // console.log('this ' + this.getIsLunchTime)
      this.setLunchTime()
      // console.log('this ' + this.getIsLunchTime)
      return this.getIsLunchTime
    },
    // productType1: {
    //   get () {
    //     return this.$store.state.form.orderType
    //   },
    //   set (orderType) {
    //     // console.log(lieferzeit)
    //     this.$store.commit('SET_ORDERTYPE', orderType)
    //     // this.$store.commit('updateMessage', value)
    //   }
    // },
    productTypeVec () {
      var typeVec = []
      var selection = this.product
      if (!selection.auswahl.length) {
        typeVec = selection.type
      }
      if (selection.auswahl.length) {
        var auswahl = this.product.auswahl[this.currentAuswahl]
        typeVec = auswahl.type
        // this.productType = typeVec[0]
      }

      watchEffect(() => {
        this.productType = typeVec[0]
        this.curScharfeStufe = this.getScharfeStufe()
      })
      // console.log(selection)
      // console.log(typeVec.length)
      // console.log('showDetails: ' + this.showDetails)
      // console.log('isexanded: ' + this.isExpanded)
      return typeVec
    },
    normal_price () {
      var selection = this.product
      var curPrice = this.product.price_portion1
      // if (this.product.auswahl.length) {
      if (this.productPortion === selection.portion1) {
        // console.log(this.productPortion)
        curPrice = selection.price_portion1
      }
      if (this.productPortion === selection.portion2) {
        // console.log(this.productPortion)
        curPrice = selection.price_portion2
      }
      if (this.productPortion === selection.portion3) {
        // console.log(this.productPortion)
        curPrice = selection.price_portion3
      }
      return curPrice
    },
    decrease_price () {
      var decrease = 0.00
      if (this.isLunchTime) {
        decrease = this.product.lunch_price_decrease
        // curPrice + curPrice * this.product.lunch_price_decrease/ 100
      } else {
        decrease = this.product.dinner_price_decrease
        // console.log(increase)
      }
      return decrease
    },
    currentPrice () {
      var curPrice = this.normal_price
      var decrease = this.decrease_price
      // console.log(curPrice)
      curPrice = curPrice - curPrice * decrease
      curPrice = this.runden(curPrice) / 1

      // console.log(curPrice)
      return curPrice
    },
    increasedPrice () {
      var aufprice = 0
      if (this.product.auswahl.length) {
        var selection = this.product.auswahl[this.currentAuswahl]
        if (this.productPortion === selection.portion1) {
          aufprice = selection.price_portion1_increase
        }
        if (this.productPortion === selection.portion2) {
          aufprice = selection.price_portion2_increase
        }
        if (this.productPortion === selection.portion3) {
          aufprice = selection.price_portion3_increase
        }
      }
      return aufprice
    },
    finalPrice () {
      return this.currentPrice + this.increasedPrice
    }

  },
  methods: {
    ...mapActions({
      setLunchTime: 'setLunchTime',
      addProductToCart: 'addProductToCart'

    }),
    expandDetails () {
      this.isExpanded = !this.isExpanded
      // this.showDetails = !this.showDetails
      this.$emit('expanded', this.product.id)
    },
    getScharfeStufe () {
      var scharfeStufe = ''
      if (this.product.scharfeStufe.length) {
        return this.product.scharfeStufe[0].type
      }

      return scharfeStufe
    },
    runden (x) {
      var xx = Number.parseFloat(x).toFixed(1)
      return Number.parseFloat(xx).toFixed(2)
    },
    increaseQuantity () {
      // food.item
      ++this.quantity
    },
    decreaseQuantity () {
      // food.item--
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    addToCart () {
      this.$emit('add-to-cart')
      this.isProductInCart = true
      // console.log('start')
      // console.log('quantity: ' + this.quantity)
      // console.log('posnr: ' + this.product.posnr)
      // console.log('curScharfeStufe: ' + this.curScharfeStufe)
      // console.log('currentAuswahl: ' + this.currentAuswahl)
      // console.log(this.product.auswahl[this.currentAuswahl])
      // console.log(this.ihreExtras)
      // console.log(this.currentPrice)
      // console.log('end')
      // update price based on the selection
      // var aufprice = this.product.auswahl[this.currentAuswahl].aufprice
      // if (aufprice > 0) {
      //   this.selectedItems.currentPrice = this.currentPrice + aufprice
      // } else {
      //   this.selectedItems.currentPrice = this.currentPrice
      // }
      // var deleveryCost = 0.0
      // if (this.finalPrice < 35) {
      //   deleveryCost = 1.0
      // } else {
      // //   deleveryCost = 0.0
      // // }
      // this.setDeleveryCost(1.0)
      this.selectedItems.currentPrice = this.finalPrice
      this.selectedItems.name = this.product.name
      this.selectedItems.inventory = this.product.inventory
      this.selectedItems.posnr = this.product.posnr
      this.selectedItems.curScharfeStufe = this.curScharfeStufe
      this.selectedItems.productType = this.productType
      this.selectedItems.productPortion = this.productPortion
      this.selectedItems.quantity = this.quantity
      this.selectedItems.currentAuswahl = this.product.auswahl[this.currentAuswahl]
      this.selectedItems.ihreExtras = this.ihreExtras
      this.selectedItems.cartTotal = this.cartTotal + this.selectedItems.currentPrice
      // this.selectedItems.gesammtKosten = this.gesammtKosten + this.selectedItems.currentPrice + this.lieferkosten
      this.addProductToCart(this.selectedItems)
    },
    getIncreasedPrice (mySelection) {
      var selection = mySelection
      var aufprice = 0
      if (this.productPortion === selection.portion1) {
        aufprice = selection.price_portion1_increase
      }
      if (this.productPortion === selection.portion2) {
        aufprice = selection.price_portion2_increase
      }
      if (this.productPortion === selection.portion3) {
        aufprice = selection.price_portion3_increase
      }
      return aufprice
    }
  }

}
</script>
<style scoped>
.list_item_even_class{
      background-color: #f1f9f9;
   }
   .list_item_odd_class{
     background-color: #f5f5f5;
   }
   #noDetails{
     display:none;
   }
   #showDetails{
     display:inline-block;
   }
   .fadein, .fadeout {
    opacity: 0;
    -moz-transition: opacity 0.4s ease-in-out;
    -o-transition: opacity 0.4s ease-in-out;
    -webkit-transition: opacity 0.4s ease-in-out;
    transition: opacity 0.4s ease-in-out;
}
.fadein {
    opacity: 1;
}

</style>
